import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const ChatApi = createApi({
    reducerPath: "ChatApi",
    baseQuery: fetchBaseQuery({
        baseUrl: `${process.env.REACT_APP_API_URL}/api/user/chat`,
    }),
    tagTypes: ["ChatData"],
    endpoints: (builder) => ({
        getChatData: builder.query({
            query: ({ userId, page = 1, limit = 10 }) => `/view/with/paginate/${userId}?page=${page}&limit=${limit}`,
            providesTags: (results, error) => [
                { type: "ChatData", results, error, id: "LIST" },
            ],
        }),
    }),
});

export const {
    useGetChatDataQuery,
} = ChatApi;
